import api from "api";

import { AutoGiftsForm } from "../components/AutoGiftForm";

export const NewAutoGift = () => {
  return <AutoGiftsForm titlePrefix="Add" apiCall={api.autoGifts.post} />;
};
